
  <div
    #modal
    *ngIf="_showModal"
    aria-hidden="true"
    class="new-modal"
    [ngClass]="{ 'new-tradeIn-modal': _sourceComponent === 'tradein-modal' }"
    (click)="_closeModal($event)"
    role="dialog"
  >
    <div
      class="new-modal-dialog"
      [ngClass]="{
        'new-tradeIn-modal-dialog': _sourceComponent === 'tradein-modal'
      }"
    >
      <div
        class="new-modal-content"
        [ngClass]="{
          'new-tradeIn-modal-content': _sourceComponent === 'tradein-modal'
        }"
        [ngStyle]="{ backgroundColor: customBgColor }"
        (click)="$event.stopPropagation()"
      >
        <ng-content></ng-content>
        <button
          #closeModalRef
          aria-label="Close dialog"
          class="new-modal-close"
          [ngClass]="{
            'new-tradeIn-modal-close': _sourceComponent === 'tradein-modal'
          }"
          data-dismiss="modal"
          (click)="_closeModal($event)"
          *ngIf="_sourceComponent !== 'rebateViewDetails'"
        >        
        <span class="dt-icon dt-icon-myprofile-Close"></span>       
        </button>
      </div>
    </div>
  </div>
